<template lang="pug">
  q-page.chipping.q-pa-sm
    .row.gutter-md
      .col-12
        geometry-editor(:d="d", :r="r", :z="z", :d_eff="d_eff", :d_flat="d_flat", :ap="ap", :ae="ae", :vc="vc", :vf="vf", :fz="fz")
    .row.gutter-md
      .col-12
        q-card
          q-card-main
            .row.gutter-md
              .col-6
                q-field(label-width="2", helper="axial doc")
                  q-input(v-model="ap", type="number" suffix="mm")
                  div(slot="label", v-katex="'a_p'")
                q-field(label-width="2", helper="radial doc")
                  q-input(v-model="ae", type="number" suffix="mm")
                  div(slot="label", v-katex="'a_e'")
                q-field(label-width="2", helper="feed per tooth")
                  q-input(v-model="fz", type="number" suffix="mm/min")
                  div(slot="label", v-katex="'f_z'")
              .col-6
                q-field(label-width="2", helper="cusp height")
                  .row.gutter-md.flex
                    .col
                      q-input(v-model="Rz", type="number" suffix="μm")
                    .col-auto
                      q-btn(round icon="fa fa-calculator" @click="compute('Rz')")
                  div(slot="label", v-katex="'R_z'")
                q-field(label-width="2", helper="roughness")
                  .row.gutter-md.flex
                    .col
                      q-input(v-model="Ra", type="number" suffix="μm")
                    .col-auto
                      q-btn(round icon="fa fa-calculator" @click="compute('Ra')")
                  div(slot="label", v-katex="'R_a'")
                q-field(label-width="2", helper="average chip thickness")
                  q-input(v-model="hm_ap", type="number" suffix="mm")
                  div(slot="label", v-katex="'h_{m,a_p}'")
                q-field(label-width="2", helper="average chip thickness")
                  q-input(v-model="hm_ae", type="number" suffix="mm")
                  div(slot="label", v-katex="'h_{m,a_e}'")
    .row
      .col-12
        q-card
          q-card-main
            cusp-height(:r="r", :ap="ap", :ae="ae")
</template>

<script>
import CuttingParameters from '@/lib/cutting-parameters.js';
import CuttingDataMixin from '@/mixins/cutting-data.js';
import GeometryEditor from '@/components/GeometryEditor.vue';
import CuspHeight from '@/components/CuspHeight.vue';

export default {
  name: 'chipping',
  components: {
    GeometryEditor,
    CuspHeight
  },
  mixins: [CuttingDataMixin],
  data: function () {
    return {
    };
  },
  computed: {
  },
  methods: {
    compute (name) {
      this.calculate('ae', name);
      this.updateDependecies('ae');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
